import React, { useEffect, useState } from "react";
import LayoutSelect from "./LayoutSelect";
import FeedbackModal from "../../TicketModal/FeedbackModal";
import FilterTicComponent from "../Filter/FilterTicComponent";
import ToastMessage from "../../../../../common/ToastMessage";
import CustomDataGrid from "../../../../../common/CustomDataGrid";
import FilterBtn from "../../../Assets/Components/Header/FilterBtn";
import useTickets from "../../../../../store/ReactQueries/tickets/useTicket";
import useDeleteTicket from "../../../../../store/ReactQueries/tickets/useDeleteTicket";
import { FormViewType } from "../../Tickets";
import useTicketColumns, { hideColumns } from "./TicketColumns";
import { darkModeBackgroud } from "../../../../../utils/constants";
import { FieldErrors } from "../../../../../domain/helpers/Errors";
import { DataSelectType } from "../../../../../models/DataSelectType";
import { useLanguageStore } from "../../../../../store/useLanguageStore";
import { useDarkModeStore } from "../../../../../store/useDarkModeStore";
import { TicketInterface } from "../../../../../models/TicketModule/Ticket";

interface TableViewFormProps {
  page: number;
  loading: boolean;
  pageSize: number;
  formView: FormViewType;
  form: TicketInterface;
  openFeedback: boolean;
  showFilters: boolean;
  filterData: DataSelectType[] | undefined;
  handleFeedback: () => void;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  setPageSize: React.Dispatch<React.SetStateAction<number>>;
  setShowFilters: React.Dispatch<React.SetStateAction<boolean>>;
  setOpenFeedback: React.Dispatch<React.SetStateAction<boolean>>;
  setForm: React.Dispatch<React.SetStateAction<TicketInterface>>;
  setFormView: React.Dispatch<React.SetStateAction<FormViewType>>;
  setFilterData: React.Dispatch<React.SetStateAction<DataSelectType[] | undefined>>;
}

export const TableViewForm: React.FC<TableViewFormProps> = ({
  page,
  form,
  pageSize,
  loading,
  formView,
  filterData,
  showFilters,
  openFeedback,
  setForm,
  setPage,
  setPageSize,
  setFormView,
  setFilterData,
  setShowFilters,
  handleFeedback,
  setOpenFeedback,
}) => {

  const { language } = useLanguageStore();
  const { darkMode } = useDarkModeStore();
  let {
    data: tickets,
    isLoading,
    error: ticketErrors,
  } = useTickets(page, pageSize, filterData);
  const upHideColumns = [...hideColumns];

  const deleteTicket = useDeleteTicket(page, pageSize);
  const handleCloseFeedback = () => setOpenFeedback(false);
  const [errors, setErrors] = useState<FieldErrors>({});

  const handleDelete = async (id: string) => {
    if (await ToastMessage.Confirm(language["ToastDeleteItem"])) {
      deleteTicket.mutate(id, {
        onSuccess: () => ToastMessage.Success(),
        onError: (error: any) => {
          console.log(error, 'error');
          if (error) ToastMessage.Failed(error?.response?.data?.Message ?? error.message);
          else ToastMessage.Failed();
        },
      });
    }
  };

  useEffect(() => {
    if (ticketErrors) ToastMessage.Failed(ticketErrors.message);
  }, [ticketErrors]);

  const ticketColumns = useTicketColumns();

  return <React.Fragment>
    <div className="w-100 p-2 d-flex align-items-center">
      <div className="ms-auto d-flex flex-row gap-1">
        <LayoutSelect
          size="small"
          module="Tickets"
          formView={formView}
          setFormView={setFormView}
        />
        {
          setShowFilters &&
          <FilterBtn
            showFilters={showFilters ?? false}
            setShowFilters={setShowFilters}
          />
        }
      </div>
    </div>
    <div className={`d-flex flex-row transition-wrapper ${!showFilters && 'gap-0'}`}>
      <div className={`content ${showFilters ? "shrink" : ""}`}>
        <CustomDataGrid
          name={language["Tickets"]}
          rows={tickets || []}
          columns={ticketColumns}
          hideColumns={upHideColumns}
          form={form}
          errors={errors}
          addItems={() => { }}
          newAddComponent="Ticket"
          showColumnModal={[]}
          handleSave={function (): Promise<void> {
            throw new Error("Function not implemented.");
          }}
          modal={{
            add: false,
            edit: false,
            view: false,
          }}
          setModal={function (
            value: React.SetStateAction<{
              add: boolean;
              edit: boolean;
              view: boolean;
            }>
          ): void {
            throw new Error("Function not implemented.");
          }}
          page={page}
          loading={isLoading}
          pageSize={pageSize}
          setPage={setPage}
          setForm={setForm}
          setErrors={setErrors}
          setPageSize={setPageSize}
          handleDelete={handleDelete}
          handleFeedback={handleFeedback}
        />
      </div>
      <div
        className={`filter-section ${showFilters ? "expand" : ""}`}
        style={{
          background: darkMode ? darkModeBackgroud : 'white',
          border: showFilters ? '1px solid rgba(224, 224, 224, 1)' : 'none',
        }}
      >
        {
          showFilters
          && <FilterTicComponent
            page={page}
            pageSize={pageSize}
            filterData={filterData}
            showFilters={showFilters}
            setPage={setPage}
            setFilterData={setFilterData}
          />
        }
      </div>
    </div>
    {
      openFeedback
      && <FeedbackModal
        open={openFeedback}
        ticketId={form.id || ""}
        handleClose={handleCloseFeedback}
      />
    }
  </React.Fragment>
};
export default TableViewForm;
